import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VeeValidate from './veeValidate'
import VueTouch from 'vue-touch'
import VueParallaxJs from 'vue-parallax-js'
import env from 'src/../env.js'

import App from './App'

import { router } from './router'
import store from './store'
import * as types from 'store/modules/login/mutation-types'
import { sync } from 'vuex-router-sync'
sync(store, router)

import 'font-awesome/css/font-awesome.min.css'
import 'sweetalert/dist/sweetalert.css'
import 'bootstrap'
import 'animate.css'
import _ from 'lodash'

import hrmsTable from 'components/hrmsTableTemplate/component'
import hrmsSearchBox from 'components/hrmsSearchBox/component'
import hrmsSearchBoxTable from 'components/hrmsSearchBoxTable/component'
import hrmsDatepicker from 'components/hrmsDatepicker/component'
import hrmsTimepicker from 'components/hrmsTimepicker/component'
import hrmsNumInput from 'components/hrmsNumInput/component'
import hrmsLovCodcomp from 'components/hrmsLovCodcomp/component'
import hrmsLovCodcomp2 from 'components/hrmsLovCodcomp2/component'
import hrmsLov from 'components/hrmsLov/component'
import hrmsStaappr from 'components/hrmsStaappr/component'
import hrmsDropdown from 'components/hrmsDropdown/component'
import hrmsDropdownMonth from 'components/hrmsDropdownMonth/component'
import hrmsDropdownYear from 'components/hrmsDropdownYear/component'
import hrmsInfiniteLoading from 'vue-infinite-loading'
import hrmsDropzone from 'components/hrmsDropzone/component'
import hrmsDropzoneMulti from 'components/hrmsDropzoneMulti/component'
import hrmsLogicalStatement from 'components/hrmsLogicalStatement/component'

const configLabels = require('src/../config/label')

// overrided _.isEmpty for check isEmpty of object with command _.isEmpty(obj, true)
_.mixin(function () {
  var _isEmpty = _.isEmpty
  return {
    isEmpty: function (value, defined) {
      if (defined && _.isObject(value)) {
        return !_.some(value, function (value, key) {
          return !_isEmpty(value)
        })
      }
      return _isEmpty(value)
    }
  }
}())

VueTouch.config.swipe = {
  direction: 'horizontal',
  threshold: 200
}
VueTouch.registerCustomEvent('doubletap', {
  type: 'tap',
  taps: 2
})
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VeeValidate)
Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(VueParallaxJs)
Vue.component('hrms-table', hrmsTable)
Vue.component('hrms-search-box', hrmsSearchBox)
Vue.component('hrms-search-box-table', hrmsSearchBoxTable)
Vue.component('hrms-datepicker', hrmsDatepicker)
Vue.component('hrms-timepicker', hrmsTimepicker)
Vue.component('hrms-num-input', hrmsNumInput)
Vue.component('hrms-lov-codcomp', hrmsLovCodcomp)
Vue.component('hrms-lov-codcomp2', hrmsLovCodcomp2)
Vue.component('hrms-lov', hrmsLov)
Vue.component('hrms-staappr', hrmsStaappr)
Vue.component('hrms-dropdown', hrmsDropdown)
Vue.component('hrms-dropdown-month', hrmsDropdownMonth)
Vue.component('hrms-dropdown-year', hrmsDropdownYear)
Vue.component('hrms-infinite-loading', hrmsInfiniteLoading)
Vue.component('hrms-dropzone', hrmsDropzone)
Vue.component('hrms-dropzone-multi', hrmsDropzoneMulti)
Vue.component('hrms-logical-statement', hrmsLogicalStatement)

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

if (store.getters[types.GET_LANG] !== window.localStorage.getItem(env.site + '_lang')) {
  if (window.localStorage.getItem(env.site + '_lang')) {
    store.commit(types.SET_LANG, window.localStorage.getItem(env.site + '_lang'))
  } else {
    store.commit(types.SET_LANG, configLabels.defaultLang)
  }
}

if (JSON.parse(window.localStorage.getItem(env.site + '_currentUser')) === null) {
  window.localStorage.setItem(env.site + '_currentUser', JSON.stringify({}))
}

if (store.getters[types.GET_CURRENT_USER] !== JSON.parse(window.localStorage.getItem(env.site + '_currentUser'))) {
  store.commit(types.SET_CURRENT_USER, JSON.parse(window.localStorage.getItem(env.site + '_currentUser')))
}

let authStatus = JSON.parse(window.localStorage.getItem(env.site + '_authStatus'))
if (authStatus === null) {
  authStatus = { status: false }
}
if (authStatus.status) {
  authStatus.timestamp = new Date().getTime()
  window.localStorage.setItem(env.site + '_authStatus', JSON.stringify(authStatus))
  store.commit(types.SET_AUTH_STATUS, authStatus)
} else {
  if (store.getters[types.GET_AUTH_STATUS] !== authStatus) {
    store.commit(types.SET_AUTH_STATUS, authStatus)
  }
}



// WEBPACK FOOTER //
// ./src/main.js